export const webStyle = {
  outlineStyle: 'none'
};
